import { SnackbarVariantsEnum } from '../_props';

/**
 * Snackbar Variants Classes
 */

const snackbarVariantClassesMap = new Map([
  [SnackbarVariantsEnum.Primary, 'bg-site-neutrals-900'],
  [SnackbarVariantsEnum.Secondary, 'bg-site-primary-50'],
]);

/**
 * Snackbar Content Classes
 */

const snackbarContentVariantClassesMap = new Map([
  [SnackbarVariantsEnum.Primary, 'font-bold text-white'],
  [SnackbarVariantsEnum.Secondary, 'text-site-neutrals-600'],
]);

/**
 * Snackbar Content Classes
 */

const snackbarContentClasses = 'site-paragraph-m font-normal flex-1';
/**
 * Snackbar Blog Theme
 */

const snackbarClassesEach = 'mdS:justify-center justify-start';
const snackbarContainerClassesTheme = 'w-[calc(100%-4rem)] mdS:w-auto';

const snackbarSiteTheme = {
  snackbarVariantClassesMap,
  snackbarContentVariantClassesMap,
  snackbarContentClasses,
  snackbarClassesEach,
  snackbarContainerClassesTheme,
};

export default snackbarSiteTheme;
